const i18n = require("react-i18next");

exports.useLang = () => {
  const {
    i18n: { language },
  } = i18n.useTranslation();

  return language;
};
